import React, { useEffect, useCallback, useState } from 'react'
import { ViewPropTypes } from 'react-native'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import SelectInput from '../SelectInput'
import { fethOrigin, fethDestination } from '../../redux/locations/locationsActions'
import { getLocationFilterText } from '../../tools/dataParse'
import { locationSelector } from '../../redux/locations/locationsSelector'

const LocationsSelectInput = (props) => {
  const { name, selected, onChange, multiselect, error, origin, label, style, placeholder, testID } = props

  const [filters, setFilters] = useState({
    location: '',
    offset: 0
  })
  const {
    loadingOriginLocations, originLocations, destinationLocations, loadingDestinationLocations,
    noMoreOriginLocations, noMoreDestinationLocations, loadingOriginPage, loadingDestinationPage
  } = useSelector(locationSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchAction = origin ? fethOrigin : fethDestination
    dispatch(fetchAction(filters))
  }, [dispatch, origin, filters])

  const filterLocations = useCallback((value) => {
    setFilters({
      location: value,
      offset: 0
    })
  }, [])

  const handleLoadMore = useCallback(() => {
    const noMore = origin ? noMoreOriginLocations : noMoreDestinationLocations
    const loadMore = origin ? loadingOriginLocations : loadingDestinationLocations
    if (noMore || loadMore) return
    setFilters({
      ...filters,
      offset: filters.offset + 1
    })
  }, [filters, loadingDestinationLocations, loadingOriginLocations, noMoreDestinationLocations, noMoreOriginLocations, origin])

  const getLocationLabel = useCallback((option) => getLocationFilterText(option), [])

  return (
    <SelectInput
      name={name}
      label={label}
      selected={selected}
      onChange={onChange}
      icon={origin ? 'Location' : 'Flag'}
      placeholder={placeholder}
      multiselect={multiselect}
      keyProp='location_id'
      nameProp='state'
      options={origin ? originLocations : destinationLocations}
      loading={origin ? loadingOriginLocations : loadingDestinationLocations}
      filterAsync={filterLocations}
      error={error}
      getOptionLabel={getLocationLabel}
      containerStyle={style}
      pagination
      noMoreOptions={origin ? noMoreOriginLocations : noMoreDestinationLocations}
      loadMore={handleLoadMore}
      globalLoading={origin ? loadingOriginPage : loadingDestinationPage}
      testID={testID}
    />
  )
}

LocationsSelectInput.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.any,
  onChange: PropTypes.func,
  multiselect: PropTypes.bool,
  error: PropTypes.string,
  origin: PropTypes.bool,
  style: ViewPropTypes.style,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  testID: PropTypes.string
}

LocationsSelectInput.defaultProps = {
  name: '',
  label: '',
  selected: null,
  placeholder: '',
  icon: '',
  onChange: () => {},
  multiselect: false,
  error: '',
  origin: false,
  destination: false
}

export default LocationsSelectInput
